/**
 * Widget status response telling us who/what is online/away.
 * Mostly copied over from cascade with added Department info.
 * @prop {Number} o Operator id for direct to op chat.
 * @prop {Array<Object>} d Department id/name data
 * @prop {String} c Coop id.
 * @prop {Boolean} away Is the entity marked as away.
 */
export default class StatusResponse {
    constructor({
        u = 0,
        d = [],
        c = '',
        away = false
    } = {},
    departments = []
    ) {
        this.u = Number(u);
        this.d = [];
        if (Array.isArray(d)) {
            d.forEach((deptId) => {
                if (departments[deptId]) {
                    this.d.push(departments[deptId]);
                }
            });
        }
        this.c = c;
        this.away = !!away;
    }
    get opId() {
        return this.u;
    }
    get deptIds() {
        return this.d;
    }
    get coopId() {
        return this.c;
    }
    get isAway() {
        return this.away;
    }
    get isOffline() {
        return this.u <= 0 && this.d.length === 0 && !this.c;
    }
    /**
     * Sometimes we just want the first available department.
     * Esp. if there is only one.
     * @returns {Object}
     */
    getFirstDept() {
        return this.d[0] || {};
    }
    /**
     * Is it an online status of any kind.
     */
    get isOnline() {
        return this.u > 0 || this.d.length > 0 || this.c !== '';
    }
}
